import { LocaleAdapterProvider as e, useLocaleAdapter as t } from "./adapter/LocaleAdapterContext.mjs";
import { changeLanguage as n, ensureLocaleLoaded as r, i18n as i, isLocaleLoaded as a } from "./i18n.mjs";
import { createContext as o, useContext as s, useEffect as c, useState as l } from "react";
import { Fragment as u, jsx as d } from "react/jsx-runtime";
import { I18nextProvider as f } from "react-i18next";
import { setActiveDateLocale as p, setRelativeTranslate as m } from "@maat/datetime";
m((e, t) => i.t(`datetime:${e}`, t)), p(i.language);
var h = o({}), g = () => s(h), _ = ({ children: e }) => {
	let o = t(), [s] = l(() => o.getInitialLocale()), [f, m] = l(() => a(s));
	return c(() => {
		let e = !1;
		return (async () => {
			s === i.language ? await r(s) : await n(s);
		})().catch(() => void 0).then(() => {
			e || m(!0);
		}), () => {
			e = !0;
		};
	}, [s]), c(() => {
		let e = (e) => {
			o.setDocumentDir(i.dir(e), e), p(e);
		};
		return e(i.language), i.on("languageChanged", e), () => i.off("languageChanged", e);
	}, [o]), f ? /* @__PURE__ */ d(u, { children: e }) : null;
}, v = ({ children: t, adapter: n, translateApiKey: r }) => {
	let a = /* @__PURE__ */ d(f, {
		i18n: i,
		children: /* @__PURE__ */ d(h.Provider, {
			value: { translateApiKey: r },
			children: /* @__PURE__ */ d(_, { children: t })
		})
	});
	return n ? /* @__PURE__ */ d(e, {
		adapter: n,
		children: a
	}) : a;
};
//#endregion
export { v as I18nProvider, g as useTranslateConfig };
